(function () {
  'use strict';

  var UNICODE_FRACTIONS = {
    '¼': 0.25,
    '½': 0.5,
    '¾': 0.75,
    '⅓': 1 / 3,
    '⅔': 2 / 3
  };
  var FRACTIE_MAP = { 0.25: '¼', 0.5: '½', 0.75: '¾' };

  var NUM = '(?:\\d+\\s+\\d+\\s*\\/\\s*\\d+|\\d+\\s*\\/\\s*\\d+|\\d+(?:[.,]\\d+)?\\s*[\\u00BC\\u00BD\\u00BE]|[\\u00BC\\u00BD\\u00BE\\u2153\\u2154]|\\d+(?:[.,]\\d+)?)';
  var SEP = '(\\s*(?:tot|of|à|\\-|\\u2013)\\s*)';
  var FRONT_RE = new RegExp('^(' + NUM + ')(?:' + SEP + '(' + NUM + '))?');

  var RE_SPOON = /^(el|tl|eetlepels?|theelepels?|koffielepels?|dessertlepels?|kopjes?|snufjes?|mespuntjes?|scheutjes?|handjes?)$/;
  var RE_GRAM = /^(g|gr|gram|grammen|mg|ml|milliliters?|mililiters?)$/;
  var RE_BULK = /^(kg|kilo|kilogram|kilogrammen|l|lt|liters?|dl|deciliters?|cl|centiliters?|pond|ons)$/;

  // [enkelvoud, meervoud, ...extra meervoudsvormen]
  var EENHEDEN = [
    ['eetlepel', 'eetlepels'], ['theelepel', 'theelepels'], ['teentje', 'teentjes'], ['teen', 'tenen'],
    ['snufje', 'snufjes'], ['stuk', 'stukken'], ['plak', 'plakken'], ['blik', 'blikken'],
    ['kopje', 'kopjes'], ['eidooier', 'eidooiers'], ['ei', 'eieren'], ['ui', 'uien'],
    ['takje', 'takjes'], ['bos', 'bossen'], ['bosje', 'bosjes'], ['pakje', 'pakjes'], ['pak', 'pakken'],
    ['bol', 'bollen'], ['pitabroodje', 'pitabroodjes'], ['broodje', 'broodjes'], ['bun', 'buns'],
    ['chunk', 'chunks'], ['spiesje', 'spiesjes'], ['spies', 'spiezen', 'spiesen'],
    ['paprika', 'paprika\u2019s', 'paprika\'s', 'paprikas'], ['tomaat', 'tomaten'],
    ['aardappel', 'aardappelen', 'aardappels'], ['wortel', 'wortelen', 'wortels'],
    ['citroen', 'citroenen'], ['limoen', 'limoenen'], ['komkommer', 'komkommers'],
    ['zak', 'zakken'], ['fles', 'flessen'], ['kipfilet', 'kipfilets'], ['kippendij', 'kippendijen'],
    ['wing', 'wings'], ['braadworst', 'braadworsten'], ['worst', 'worsten'],
    ['champignon', 'champignons'], ['courgette', 'courgettes'], ['sinaasappel', 'sinaasappelen', 'sinaasappels'],
    ['vanillestokje', 'vanillestokjes'], ['satéprikker', 'satéprikkers']
  ];
  var EENHEID_MAP = {};
  EENHEDEN.forEach(function (e) {
    e.forEach(function (vorm) { EENHEID_MAP[vorm] = e; });
  });
  EENHEID_MAP.stuks = EENHEID_MAP.stuk;
  // g/ml worden vanaf 1000 kg/l (mg blijft mg)
  var GRAM_NAAR_BULK = { g: 'kg', gr: 'kg', gram: 'kilo', grammen: 'kilo', ml: 'l', milliliter: 'liter', milliliters: 'liter', mililiter: 'liter', mililiters: 'liter' };

  function parseGetal(t) {
    t = String(t).trim();
    for (var uf in UNICODE_FRACTIONS) {
      if (t.indexOf(uf) !== -1) {
        var rest = t.replace(uf, '').trim();
        var whole = rest ? parseFloat(rest.replace(',', '.')) : 0;
        return (isNaN(whole) ? 0 : whole) + UNICODE_FRACTIONS[uf];
      }
    }
    var mixed = t.match(/^(\d+)\s+(\d+)\s*\/\s*(\d+)$/);
    if (mixed) return parseInt(mixed[1], 10) + parseInt(mixed[2], 10) / parseInt(mixed[3], 10);
    var frac = t.match(/^(\d+)\s*\/\s*(\d+)$/);
    if (frac) return parseInt(frac[1], 10) / parseInt(frac[2], 10);
    var num = parseFloat(t.replace(',', '.'));
    return isNaN(num) ? NaN : num;
  }

  function unitCategorie(unit) {
    var u = String(unit || '').toLowerCase();
    if (RE_SPOON.test(u)) return 'spoon';
    if (RE_GRAM.test(u)) return 'gram';
    if (RE_BULK.test(u)) return 'bulk';
    return 'stuk';
  }

  function parseHoeveelheid(tekst) {
    if (typeof tekst !== 'string') return null;
    var s = tekst;
    var prefix = '';
    var pm = s.match(/^(ca\.|circa|ongeveer)\s+/i);
    if (pm) { prefix = pm[0]; s = s.slice(pm[0].length); }
    var m = FRONT_RE.exec(s);
    if (!m) return null;
    var n1 = parseGetal(m[1]);
    if (isNaN(n1)) return null;
    var n2 = m[3] ? parseGetal(m[3]) : null;
    var sepRaw = m[2] || null;
    var sepKey = sepRaw ? sepRaw.trim() : null;
    var rest = s.slice(m[0].length);
    var unitMatch = rest.match(/^\s*([^\s]+)/);
    var unit = unitMatch ? unitMatch[1].replace(/[.,;:]+$/, '') : '';
    var lowRest = rest.replace(/^\s+/, '').toLowerCase();
    var niet = false;
    if (/^(°|graden?\b|minuten?\b|min\b|uur\b|seconden?\b|sec\b|cm\b|mm\b|meter\b)/.test(lowRest)) niet = true;
    if ((sepKey === '-' || sepKey === '–') && /^[-–]\s*\d/.test(rest)) niet = true;
    return { prefix: prefix, n1: n1, n2: n2, sep: sepKey, sepRaw: sepRaw, rest: rest, unit: unit, nietScaleren: niet };
  }

  function breukTekst(q) {
    var whole = Math.floor(q + 1e-9);
    var frac = Math.round((q - whole) * 100) / 100;
    if (frac === 0) return String(whole);
    var sym = FRACTIE_MAP[frac];
    if (!sym) return decimaalTekst(q, 2);
    return whole > 0 ? String(whole) + sym : sym;
  }

  function afronden(v, dec) {
    var f = Math.pow(10, dec);
    return Math.round(v * f + 1e-9) / f;
  }

  function decimaalTekst(v, dec) {
    var r = afronden(v, dec);
    if (Math.abs(r - Math.round(r)) < 1e-9) return String(Math.round(r));
    return String(r).replace('.', ',');
  }

  function formatHoeveelheid(value, cat) {
    if (!(value > 0)) return { s: '0', n: 0 };
    var n, stap;
    if (cat === 'spoon') {
      stap = value < 5 ? 0.25 : (value < 20 ? 0.5 : 1);
      n = Math.round(value / stap + 1e-9) * stap;
      if (n < 0.25) n = 0.25;
      return { s: breukTekst(n), n: n };
    }
    if (cat === 'gram') {
      if (value >= 500) n = Math.round(value / 10 + 1e-9) * 10;
      else if (value >= 10) n = Math.round(value / 5 + 1e-9) * 5;
      else if (value >= 2) n = Math.round(value);
      else n = afronden(value, 1);
      if (n === 0) n = afronden(value, 2);
      if (n === 0) n = 0.01;
      return { s: decimaalTekst(n, 2), n: n };
    }
    if (cat === 'bulk') {
      n = Math.round(value / 0.05 + 1e-9) * 0.05;
      n = afronden(n, 2);
      if (n === 0) n = afronden(value, 2);
      if (n === 0) n = 0.01;
      return { s: decimaalTekst(n, 2), n: n };
    }
    stap = value < 10 ? 0.5 : 1;
    n = Math.round(value / stap + 1e-9) * stap;
    if (n < 0.5) n = 0.5;
    return { s: breukTekst(n), n: n };
  }

  function pasWoordAan(token, enkelvoud) {
    // geeft undefined als het woord niet bekend is, anders het (eventueel aangepaste) woord
    if (token.charAt(0) === '(') return undefined;
    var m = token.match(/^([\s\S]*?)([.,;:!?)\]]*)$/);
    var kern = m[1];
    var staart = m[2];
    var entry = EENHEID_MAP[kern.toLowerCase()];
    if (!entry) return undefined;
    var isMeervoud = kern.toLowerCase() !== entry[0];
    if (kern.toLowerCase() === 'stuks' && !enkelvoud) return token;
    if (enkelvoud === !isMeervoud) return token;
    var nieuw = enkelvoud ? entry[0] : entry[1];
    if (kern.charAt(0) !== kern.charAt(0).toLowerCase()) nieuw = nieuw.charAt(0).toUpperCase() + nieuw.slice(1);
    return nieuw + staart;
  }

  // Het eerste woord (eenheid) wordt altijd aangepast als het bekend is. Alleen bij stuks (geen maat als
  // eenheid) zoeken we ook in de volgende twee woorden naar het eerste bekende zelfstandig naamwoord.
  function pasUnitAan(rest, enkelvoud, zoekNomen) {
    var delen = rest.split(/(\s+)/);
    var gezien = 0;
    for (var i = 0; i < delen.length && gezien < 3; i++) {
      if (delen[i] === '' || /^\s+$/.test(delen[i])) continue;
      if (gezien > 0 && !zoekNomen) break;
      gezien++;
      var nieuw = pasWoordAan(delen[i], enkelvoud);
      if (nieuw !== undefined) { delen[i] = nieuw; break; }
    }
    return delen.join('');
  }

  function zetUnitOm(rest, naam) {
    var m = rest.match(/^(\s*)([A-Za-zÀ-ÿ]+)([\s\S]*)$/);
    return m ? m[1] + naam + m[3] : rest;
  }

  function schaalRegel(tekst, ratio) {
    if (typeof tekst !== 'string') return tekst;
    if (!(ratio > 0) || ratio === 1) return tekst;
    var p = parseHoeveelheid(tekst);
    if (!p || p.nietScaleren) return tekst;
    var cat = unitCategorie(p.unit);
    var rest = p.rest;
    var a = formatHoeveelheid(p.n1 * ratio, cat);
    var b = p.n2 != null ? formatHoeveelheid(p.n2 * ratio, cat) : null;
    var zoekNomen = cat === 'stuk';
    if (cat === 'gram') {
      var bulkNaam = GRAM_NAAR_BULK[p.unit.toLowerCase()];
      if (bulkNaam && Math.max(a.n, b ? b.n : 0) >= 1000) {
        a = formatHoeveelheid(p.n1 * ratio / 1000, 'bulk');
        if (b) b = formatHoeveelheid(p.n2 * ratio / 1000, 'bulk');
        rest = zetUnitOm(rest, bulkNaam);
        cat = 'bulk';
      }
    }
    var out = p.prefix + a.s;
    var maxN = a.n;
    if (b && b.s !== a.s) {
      out += p.sepRaw + b.s;
      maxN = Math.max(a.n, b.n);
    }
    rest = pasUnitAan(rest, maxN <= 1, zoekNomen);
    if (rest && !/^\s/.test(rest)) out += ' ';
    return out + rest;
  }

  function q(s, root) { return (root || document).querySelector(s); }
  function qa(s, root) { return Array.prototype.slice.call((root || document).querySelectorAll(s)); }

  function hashText(str) {
    var h = 5381, i;
    str = String(str);
    for (i = 0; i < str.length; i++) { h = ((h << 5) + h) + str.charCodeAt(i); h |= 0; }
    return (h >>> 0).toString(36);
  }

  function lsGet(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function lsSet(key, val) { try { localStorage.setItem(key, val); return true; } catch (e) { return false; } }

  var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  function nieuweUuid() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
      if (window.crypto && window.crypto.getRandomValues) {
        var b = new Uint8Array(16);
        window.crypto.getRandomValues(b);
        b[6] = (b[6] & 0x0f) | 0x40;
        b[8] = (b[8] & 0x3f) | 0x80;
        var h = Array.prototype.map.call(b, function (x) { return (x < 16 ? '0' : '') + x.toString(16); }).join('');
        return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
      }
    } catch (e) {}
    return null;
  }

  function bezoekerId() {
    try {
      var id = localStorage.getItem('rk2_bezoeker');
      if (id && UUID_RE.test(id)) return id;
      id = nieuweUuid();
      if (!id) return null;
      localStorage.setItem('rk2_bezoeker', id);
      return id;
    } catch (e) {
      return null;
    }
  }

  var printHidden = [];
  var printRoot = null;
  var printWired = false;

  function hideForPrint() {
    if (printHidden.length) return;
    var rootEl = printRoot || document.querySelector('[data-rk2-recipe]');
    if (!rootEl) return;
    var node = rootEl;
    while (node && node !== document.body && node.parentNode) {
      var kids = node.parentNode.children;
      for (var i = 0; i < kids.length; i++) {
        var kid = kids[i];
        if (kid === node || kid.classList.contains('rk2-print-hide')) continue;
        kid.classList.add('rk2-print-hide');
        // inline !important wint van thema-regels als `display: inline-flex !important` met hogere specificiteit
        printHidden.push({
          el: kid,
          waarde: kid.style.getPropertyValue('display'),
          prio: kid.style.getPropertyPriority('display'),
          hadStyle: kid.hasAttribute('style')
        });
        kid.style.setProperty('display', 'none', 'important');
      }
      node = node.parentNode;
    }
  }

  function showAfterPrint() {
    printHidden.forEach(function (r) {
      var el = r.el;
      el.classList.remove('rk2-print-hide');
      if (r.waarde) el.style.setProperty('display', r.waarde, r.prio);
      else el.style.removeProperty('display');
      if (!r.hadStyle && !el.getAttribute('style')) el.removeAttribute('style');
    });
    printHidden = [];
  }

  function wirePrint() {
    if (printWired || typeof window.addEventListener !== 'function') return;
    printWired = true;
    window.addEventListener('beforeprint', hideForPrint);
    window.addEventListener('afterprint', showAfterPrint);
    if (typeof window.matchMedia === 'function') {
      var mql = window.matchMedia('print');
      var onChange = function (e) { if (e.matches) hideForPrint(); else showAfterPrint(); };
      if (mql.addEventListener) mql.addEventListener('change', onChange);
      else if (mql.addListener) mql.addListener(onChange);
    }
  }

  var turnstileWaiters = [];
  var turnstilePoll = null;

  function loadTurnstile(cb) {
    if (window.turnstile) { cb(true); return; }
    turnstileWaiters.push(cb);
    var finish = function (ok) {
      if (turnstilePoll) { clearInterval(turnstilePoll); turnstilePoll = null; }
      var list = turnstileWaiters;
      turnstileWaiters = [];
      list.forEach(function (fn) { fn(ok); });
    };
    if (!turnstilePoll) {
      var tries = 0;
      turnstilePoll = setInterval(function () {
        tries++;
        if (window.turnstile) finish(true);
        else if (tries >= 30) finish(false);
      }, 250);
    }
    if (document.querySelector('script[data-rk2-turnstile]')) return;
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true;
    s.defer = true;
    s.setAttribute('data-rk2-turnstile', '1');
    s.onload = function () { if (window.turnstile) finish(true); };
    s.onerror = function () {
      s.parentNode && s.parentNode.removeChild(s);
      finish(false);
    };
    document.head.appendChild(s);
  }

  function initRecipe(root) {
    if (!root || (root.dataset && root.dataset.rk2Init === '1')) return;
    if (root.dataset) root.dataset.rk2Init = '1';

    var dataEl = root.querySelector('script[data-rk2-data]');
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = {}; }

    var recipeId = data.id || root.getAttribute('data-recipe-id') || 'default';
    var cleanups = [];

    function listen(target, type, handler, opts) {
      target.addEventListener(type, handler, opts);
      cleanups.push(function () { target.removeEventListener(type, handler, opts); });
    }

    // --- porties schalen ---
    var originalServings = parseFloat(root.getAttribute('data-original-servings')) || parseFloat(data.servings) || 1;
    var currentServings = originalServings;
    var servingsDisplay = root.querySelector('.rk2-servings__value');
    var servingsBadge = root.querySelector('.rk2-servings-value');

    function scaleIngredients() {
      var ratio = currentServings / originalServings;
      qa('.rk2-ingredient-text', root).forEach(function (el) {
        var original = el.getAttribute('data-original-text') || el.textContent;
        var target = el.querySelector('.rk2-ingredient-link') || el;
        target.textContent = schaalRegel(original, ratio);
      });
      if (servingsBadge) servingsBadge.textContent = currentServings;
    }

    var minusBtn = root.querySelector('[data-action="decrease"]');
    var plusBtn = root.querySelector('[data-action="increase"]');
    if (minusBtn) listen(minusBtn, 'click', function () {
      if (currentServings > 1) { currentServings--; if (servingsDisplay) servingsDisplay.textContent = currentServings; scaleIngredients(); }
    });
    if (plusBtn) listen(plusBtn, 'click', function () {
      if (currentServings < 99) { currentServings++; if (servingsDisplay) servingsDisplay.textContent = currentServings; scaleIngredients(); }
    });

    // --- ingredient checkboxes ---
    function ingredientKey() {
      var texts = qa('.rk2-ingredient-text', root).map(function (el) {
        return el.getAttribute('data-original-text') || el.textContent;
      }).join('\u001f');
      return 'rk2_checked_' + recipeId + '_' + hashText(texts);
    }
    function saveCheckboxState() {
      var state = {};
      qa('.rk2-ingredient-item', root).forEach(function (item) {
        var box = item.querySelector('.rk2-ingredient-checkbox');
        var label = item.querySelector('.rk2-ingredient-text');
        if (!box || !label) return;
        state[hashText(label.getAttribute('data-original-text') || label.textContent)] = !!box.checked;
      });
      lsSet(ingredientKey(), JSON.stringify(state));
    }
    function restoreCheckboxState() {
      try {
        var saved = lsGet(ingredientKey());
        if (!saved) return;
        var state = JSON.parse(saved);
        qa('.rk2-ingredient-item', root).forEach(function (item) {
          var box = item.querySelector('.rk2-ingredient-checkbox');
          var label = item.querySelector('.rk2-ingredient-text');
          if (!box || !label) return;
          var k = hashText(label.getAttribute('data-original-text') || label.textContent);
          if (Object.prototype.hasOwnProperty.call(state, k)) box.checked = !!state[k];
        });
      } catch (e) {}
    }
    var ingContainer = root.querySelector('[data-ingredients]');
    if (ingContainer) listen(ingContainer, 'change', function (e) {
      if (e.target && e.target.classList.contains('rk2-ingredient-checkbox')) saveCheckboxState();
    });
    restoreCheckboxState();

    // --- print ---
    wirePrint();
    var printBtn = root.querySelector('[data-action="print"]');
    if (printBtn) listen(printBtn, 'click', function () { printRoot = root; window.print(); });

    // --- copy link ---
    var copyBtn = root.querySelector('[data-action="copy-link"]');
    var copyConfirm = root.querySelector('[data-copy-confirm]');
    function copyMelding(tekst, fout) {
      if (!copyConfirm) return;
      copyConfirm.textContent = tekst;
      copyConfirm.classList.toggle('rk2-copy-confirm--fout', !!fout);
      clearTimeout(copyConfirm._rk2t);
      copyConfirm._rk2t = setTimeout(function () { copyConfirm.textContent = ''; copyConfirm.classList.remove('rk2-copy-confirm--fout'); }, fout ? 6000 : 2500);
    }
    function kopieerViaExecCommand(url) {
      var veld = document.createElement('textarea');
      var vorigeFocus = document.activeElement;
      veld.value = url;
      veld.setAttribute('readonly', '');
      veld.setAttribute('aria-hidden', 'true');
      veld.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none;';
      document.body.appendChild(veld);
      var gelukt = false;
      try {
        veld.focus();
        veld.select();
        veld.setSelectionRange(0, url.length);
        gelukt = !!document.execCommand('copy');
      } catch (e) { gelukt = false; }
      document.body.removeChild(veld);
      try { if (vorigeFocus && vorigeFocus.focus) vorigeFocus.focus(); } catch (e) {}
      return gelukt;
    }
    if (copyBtn) listen(copyBtn, 'click', function () {
      var url = window.location.origin + window.location.pathname;
      var gelukt = function () { copyMelding('Gekopieerd', false); };
      var mislukt = function () { copyMelding('Kopiëren lukt niet, kopieer de link uit de adresbalk', true); };
      var terugval = function () { if (kopieerViaExecCommand(url)) gelukt(); else mislukt(); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        var p;
        try { p = navigator.clipboard.writeText(url); } catch (e) { terugval(); return; }
        Promise.resolve(p).then(gelukt, terugval);
      } else {
        terugval();
      }
    });
    cleanups.push(function () { if (copyConfirm) clearTimeout(copyConfirm._rk2t); });

    // --- kookmodus ---
    var cookOverlay = root.querySelector('[data-cookmode]');
    var cookOpen = root.querySelector('[data-action="cook-mode"]');
    var cookHome = cookOverlay ? cookOverlay.parentNode : null;
    var cookNextSibling = cookOverlay ? cookOverlay.nextSibling : null;
    var steps = qa('.rk2-step', root).map(function (li) {
      var text = (li.querySelector('.rk2-step__text') || {}).textContent || '';
      return text.trim();
    });
    var currentStep = 0;
    var wakeLock = null;
    var inertedEls = [];
    var bodyOverflowBefore = '';
    var cookIsOpen = false;

    function getFocusable() {
      if (!cookOverlay) return [];
      return qa('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', cookOverlay).filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    function renderCookStep() {
      if (!steps.length || !cookOverlay) return;
      var progress = cookOverlay.querySelector('[data-cookmode-progress]');
      var stepLabel = cookOverlay.querySelector('[data-cookmode-step]');
      var textEl = cookOverlay.querySelector('[data-cookmode-text]');
      var prevBtn = cookOverlay.querySelector('[data-cookmode-prev]');
      var nextBtn = cookOverlay.querySelector('[data-cookmode-next]');
      var laatste = currentStep === steps.length - 1;
      if (progress) progress.textContent = 'Stap ' + (currentStep + 1) + ' van ' + steps.length;
      if (stepLabel) stepLabel.textContent = 'Stap ' + (currentStep + 1);
      if (textEl) textEl.textContent = steps[currentStep];
      if (prevBtn) prevBtn.setAttribute('aria-disabled', currentStep === 0 ? 'true' : 'false');
      if (nextBtn) {
        nextBtn.textContent = laatste ? 'Klaar' : 'Volgende';
        nextBtn.setAttribute('aria-label', laatste ? 'Klaar' : 'Volgende stap');
      }
    }

    var supportsInert = (function () {
      try { return 'inert' in document.createElement('div'); } catch (e) { return false; }
    })();

    function setBackgroundInert(on) {
      if (!cookOverlay || !document.body) return;
      if (on) {
        inertedEls = [];
        var kids = document.body.children;
        for (var i = 0; i < kids.length; i++) {
          var el = kids[i];
          if (el === cookOverlay || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;
          inertedEls.push({
            el: el,
            hadInert: el.hasAttribute('inert'),
            ariaHidden: el.getAttribute('aria-hidden')
          });
          if (supportsInert) el.setAttribute('inert', '');
          else el.setAttribute('aria-hidden', 'true');
        }
      } else {
        inertedEls.forEach(function (r) {
          if (r.hadInert) r.el.setAttribute('inert', '');
          else r.el.removeAttribute('inert');
          if (r.ariaHidden === null) r.el.removeAttribute('aria-hidden');
          else r.el.setAttribute('aria-hidden', r.ariaHidden);
        });
        inertedEls = [];
      }
    }

    function wakeLockRelease() {
      if (wakeLock && wakeLock.release) { wakeLock.release().catch(function () {}); }
      wakeLock = null;
    }

    function wakeLockRequest() {
      if (!('wakeLock' in navigator)) return;
      navigator.wakeLock.request('screen').then(function (wl) {
        if (!cookIsOpen) { wl.release().catch(function () {}); return; }
        wakeLock = wl;
      }).catch(function () {});
    }

    function onVisibility() {
      if (cookIsOpen && document.visibilityState === 'visible') wakeLockRequest();
    }

    function onCookKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); closeCookMode(); return; }
      if (e.key === 'ArrowRight') { goNext(); return; }
      if (e.key === 'ArrowLeft') { goPrev(); return; }
      if (e.key === 'Tab') {
        var f = getFocusable();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    function closeCookMode() {
      if (!cookOverlay || !cookIsOpen) return;
      cookIsOpen = false;
      document.removeEventListener('keydown', onCookKeydown);
      document.removeEventListener('visibilitychange', onVisibility);
      setBackgroundInert(false);
      cookOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = bodyOverflowBefore;
      if (cookHome) cookHome.insertBefore(cookOverlay, cookNextSibling);
      wakeLockRelease();
      if (cookOpen) cookOpen.focus();
    }

    function openCookMode() {
      if (!steps.length || !cookOverlay || cookIsOpen) return;
      cookIsOpen = true;
      currentStep = 0;
      renderCookStep();
      document.body.appendChild(cookOverlay);
      bodyOverflowBefore = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      cookOverlay.setAttribute('aria-hidden', 'false');
      setBackgroundInert(true);
      document.addEventListener('keydown', onCookKeydown);
      document.addEventListener('visibilitychange', onVisibility);
      var closeBtn = cookOverlay.querySelector('[data-cookmode-close]');
      if (closeBtn) closeBtn.focus();
      wakeLockRequest();
    }

    function goNext() {
      if (currentStep < steps.length - 1) { currentStep++; renderCookStep(); }
    }
    function goPrev() {
      if (currentStep > 0) { currentStep--; renderCookStep(); }
    }

    if (cookOpen) listen(cookOpen, 'click', openCookMode);
    var cookClose = cookOverlay ? cookOverlay.querySelector('[data-cookmode-close]') : null;
    if (cookClose) listen(cookClose, 'click', closeCookMode);
    if (cookOverlay) listen(cookOverlay, 'click', function (e) { if (e.target === cookOverlay) closeCookMode(); });

    var cookPrev = cookOverlay ? cookOverlay.querySelector('[data-cookmode-prev]') : null;
    var cookNext = cookOverlay ? cookOverlay.querySelector('[data-cookmode-next]') : null;
    if (cookNext) listen(cookNext, 'click', function () {
      if (currentStep === steps.length - 1) closeCookMode();
      else goNext();
    });
    if (cookPrev) listen(cookPrev, 'click', goPrev);

    cleanups.push(function () {
      if (cookIsOpen) closeCookMode();
      document.removeEventListener('keydown', onCookKeydown);
      document.removeEventListener('visibilitychange', onVisibility);
    });

    // --- rating ---
    var stars = qa('.rk2-star', root);
    var starGroup = root.querySelector('.rk2-rating__stars');
    var ratingValueEl = root.querySelector('.rk2-rating__value');
    var ratingCountEl = root.querySelector('.rk2-rating__count');
    var ratingThanks = root.querySelector('[data-rating-thanks]');
    var ratingError = root.querySelector('[data-rating-error]');
    var turnstileContainer = root.querySelector('[data-turnstile-container]');
    var sitekey = data.turnstileSitekey || '';
    var apiUrl = data.apiUrl || 'https://keuken.bbq-wereld.nl/api/waardering';
    var hasVotedKey = 'rk2_voted_' + recipeId;
    var scoreKey = 'rk2_score_' + recipeId;
    var voted = lsGet(hasVotedKey) === '1';
    var storedScore = parseInt(lsGet(scoreKey), 10);
    if (!(storedScore >= 1 && storedScore <= 5)) storedScore = 0;
    var pendingScore = 0;
    var busy = false;
    var widgetId = null;
    var abortCtrl = null;
    var abortTimer = null;
    var tsTimer = null;
    var wachtOpToken = false;
    // data-turnstile-timeout (ms) is er alleen zodat de test de watchdog kan verkorten
    function tsTimeoutMs() { return parseInt(root.getAttribute('data-turnstile-timeout'), 10) || 20000; }

    function updateRatingUI(value, count) {
      if (value != null && value !== '' && Number(count) >= 1) {
        if (ratingValueEl) { ratingValueEl.textContent = String(value).replace('.', ','); ratingValueEl.hidden = false; }
        if (ratingCountEl) ratingCountEl.textContent = '(' + count + ')';
      } else if (ratingCountEl) {
        ratingCountEl.textContent = 'Nog geen waarderingen';
      }
    }

    // Alleen visueel: vult alle sterren t/m n. aria-checked blijft bij de gekozen ster.
    function paintStars(n) {
      stars.forEach(function (b, i) { b.classList.toggle('rk2-star--on', i < n); });
    }

    function setStars(score) {
      var tabIdx = score >= 1 ? score - 1 : 0;
      stars.forEach(function (b, i) {
        b.setAttribute('aria-checked', i + 1 === score ? 'true' : 'false');
        b.setAttribute('tabindex', i === tabIdx ? '0' : '-1');
      });
      paintStars(score);
    }

    // aria-disabled i.p.v. disabled: een gefocuste knop die disabled wordt laat de focus naar BODY vallen
    function setStarsDisabled(disabled) {
      stars.forEach(function (b) { b.setAttribute('aria-disabled', disabled ? 'true' : 'false'); });
    }

    function showThanks() {
      if (ratingThanks) ratingThanks.textContent = 'Bedankt voor je waardering';
      if (ratingError) { ratingError.textContent = ''; ratingError.hidden = true; }
    }

    function stopWatchdog() {
      clearTimeout(tsTimer);
      tsTimer = null;
      wachtOpToken = false;
    }

    function ratingFail(msg) {
      stopWatchdog();
      busy = false;
      if (ratingError) { ratingError.textContent = msg; ratingError.hidden = false; }
      if (ratingThanks) ratingThanks.textContent = '';
      setStars(voted ? storedScore : 0);
      if (!voted && sitekey) setStarsDisabled(false);
    }

    function stopFetch() {
      clearTimeout(abortTimer);
      abortTimer = null;
      if (abortCtrl) { try { abortCtrl.abort(); } catch (e) {} abortCtrl = null; }
    }

    function removeWidget() {
      if (widgetId !== null && window.turnstile && window.turnstile.remove) {
        try { window.turnstile.remove(widgetId); } catch (e) {}
      }
      widgetId = null;
    }

    function startRating(score) {
      if (voted || busy) return;
      if (!sitekey) { ratingFail('Waarderen is tijdelijk niet beschikbaar.'); return; }
      busy = true;
      pendingScore = score;
      if (ratingError) { ratingError.textContent = ''; ratingError.hidden = true; }
      if (ratingThanks) ratingThanks.textContent = 'Bezig met controleren\u2026';
      setStars(score);
      setStarsDisabled(true);
      stopWatchdog();
      wachtOpToken = true;
      tsTimer = setTimeout(function () {
        if (!wachtOpToken) return;
        ratingFail('De beveiligingscontrole duurt te lang. Probeer het opnieuw.');
        if (widgetId !== null && window.turnstile && window.turnstile.reset) {
          try { window.turnstile.reset(widgetId); } catch (e) {}
        }
      }, tsTimeoutMs());
      loadTurnstile(function (ok) {
        if (!wachtOpToken) return;
        if (!ok) { ratingFail('De beveiligingscontrole kon niet geladen worden. Probeer het opnieuw.'); return; }
        if (!turnstileContainer) { ratingFail('Waarderen lukt nu niet. Probeer het later opnieuw.'); return; }
        if (widgetId === null) {
          try {
            widgetId = window.turnstile.render(turnstileContainer, {
              sitekey: sitekey,
              callback: function (token) {
                if (!wachtOpToken) return;
                stopWatchdog();
                submitRating(pendingScore, token);
              },
              'error-callback': function () { if (wachtOpToken) ratingFail('De beveiligingscontrole mislukte. Probeer het opnieuw.'); },
              'timeout-callback': function () { if (wachtOpToken) ratingFail('De beveiligingscontrole duurde te lang. Probeer het opnieuw.'); },
              'expired-callback': function () {
                try { window.turnstile.reset(widgetId); } catch (e) {}
              }
            });
          } catch (e) { widgetId = null; ratingFail('Waarderen lukt nu niet. Probeer het later opnieuw.'); }
        } else {
          try { window.turnstile.reset(widgetId); }
          catch (e) { ratingFail('Waarderen lukt nu niet. Probeer het later opnieuw.'); }
        }
      });
    }

    function submitRating(score, token) {
      var body = { slug: data.slug || window.location.pathname, score: score, token: token };
      var bezoeker = bezoekerId();
      if (bezoeker) body.bezoeker = bezoeker;
      stopFetch();
      abortCtrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      abortTimer = setTimeout(function () { if (abortCtrl) abortCtrl.abort(); }, 10000);
      var opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      };
      if (abortCtrl) opts.signal = abortCtrl.signal;
      fetch(apiUrl, opts)
        .then(function (res) {
          return res.json().then(function (j) { return { ok: res.ok, status: res.status, j: j }; });
        })
        .then(function (r) {
          clearTimeout(abortTimer);
          if (r.ok && r.j && r.j.ok) {
            busy = false;
            voted = true;
            storedScore = score;
            lsSet(hasVotedKey, '1');
            lsSet(scoreKey, String(score));
            updateRatingUI(r.j.waarde, r.j.aantal);
            setStars(score);
            setStarsDisabled(true);
            showThanks();
            removeWidget();
          } else {
            var msg = (r.j && (r.j.fout || r.j.error)) ? (r.j.fout || r.j.error) : (r.status === 429 ? 'Je hebt te vaak gewaardeerd. Probeer het later opnieuw.' : 'Waardering mislukt. Probeer het opnieuw.');
            ratingFail(msg);
          }
        })
        .catch(function (err) {
          clearTimeout(abortTimer);
          ratingFail(err && err.name === 'AbortError' ? 'De waardering duurde te lang. Probeer het opnieuw.' : 'Waardering mislukt. Probeer het opnieuw.');
        });
    }

    stars.forEach(function (btn, idx) {
      listen(btn, 'mouseenter', function () {
        if (voted || busy || !sitekey) return;
        paintStars(idx + 1);
      });
      listen(btn, 'click', function () {
        if (voted || busy) return;
        startRating(parseInt(btn.getAttribute('data-score'), 10));
      });
      listen(btn, 'keydown', function (e) {
        if (voted || busy) return;
        var n = stars.length;
        var next = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % n;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (idx - 1 + n) % n;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = n - 1;
        if (next < 0) return;
        e.preventDefault();
        setStars(next + 1);
        stars[next].focus();
      });
    });

    if (starGroup) listen(starGroup, 'mouseleave', function () {
      if (voted) paintStars(storedScore);
      else if (busy) paintStars(pendingScore);
      else paintStars(stars.reduce(function (n, b, i) { return b.getAttribute('aria-checked') === 'true' ? i + 1 : n; }, 0));
    });

    if (starGroup) listen(starGroup, 'focusout', function (e) {
      if (voted || busy) return;
      var to = e.relatedTarget;
      if (to && starGroup.contains(to)) return;
      setStars(0);
    });

    cleanups.push(function () {
      stopWatchdog();
      stopFetch();
      removeWidget();
    });

    if (voted) {
      setStars(storedScore);
      setStarsDisabled(true);
      showThanks();
    }

    root._rk2Destroy = function () {
      cleanups.forEach(function (fn) { try { fn(); } catch (e) {} });
      cleanups = [];
      if (root.dataset) delete root.dataset.rk2Init;
      delete root._rk2Destroy;
    };
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-rk2-recipe]');
    Array.prototype.forEach.call(roots, initRecipe);
  }

  function destroy(root) {
    if (root && typeof root._rk2Destroy === 'function') root._rk2Destroy();
  }

  var api = {
    parseHoeveelheid: parseHoeveelheid,
    schaalRegel: schaalRegel,
    unitCategorie: unitCategorie,
    formatHoeveelheid: formatHoeveelheid,
    destroy: destroy
  };
  var alGeladen = typeof window !== 'undefined' && window.__rk2Init === true;
  if (typeof window !== 'undefined') window.__rk2 = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (alGeladen) return;
  if (typeof window !== 'undefined') window.__rk2Init = true;

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  }
})();
